'use client';

import { Shield, MessageCircle, FileText, Github } from 'lucide-react';
import Image from 'next/image';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f0f0f] border-t border-[#b9bbbe]/10">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-white font-bold text-xl">Yokki</span>
            </div>
            <p className="text-[#b9bbbe] text-sm leading-relaxed">
              The all-in-one Discord bot for community protection, moderation, and engagement.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#commands" className="text-[#b9bbbe] hover:text-[#5865F2] transition-colors text-sm">
                  Commands
                </a>
              </li>
              <li>
                <a href="#" className="text-[#b9bbbe] hover:text-[#5865F2] transition-colors text-sm">
                  Features
                </a>
              </li>
              <li>
                <a href="#" className="text-[#b9bbbe] hover:text-[#5865F2] transition-colors text-sm">
                  Setup Guide
                </a>
              </li>
              <li>
                <a href="#" className="text-[#b9bbbe] hover:text-[#5865F2] transition-colors text-sm">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://discord.gg/BZkDrjG2" target="_blank" rel="noopener noreferrer" className="text-[#b9bbbe] hover:text-[#5865F2] transition-colors text-sm flex items-center gap-2">
                  <MessageCircle className="h-4 w-4" />
                  Support Discord
                </a>
              </li>
              <li>
                <a href="#" className="text-[#b9bbbe] hover:text-[#5865F2] transition-colors text-sm flex items-center gap-2">
                  <Github className="h-4 w-4" />
                  Report Issues
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-[#b9bbbe] hover:text-[#5865F2] transition-colors text-sm">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-[#b9bbbe] hover:text-[#5865F2] transition-colors text-sm">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-[#b9bbbe] hover:text-[#5865F2] transition-colors text-sm">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-[#b9bbbe]/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#b9bbbe] text-sm">
            © {currentYear} Yokki. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-[#b9bbbe] hover:text-[#5865F2] transition-colors"
              aria-label="Discord"
            >
              <MessageCircle className="h-5 w-5" />
            </a>
            <a
              href="#"
              className="text-[#b9bbbe] hover:text-[#5865F2] transition-colors"
              aria-label="GitHub"
            >
              <Github className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
